// Types
import { Icon as IconType } from '../../../types/icon';
import { Measurements } from '../../../types/measurements';

// Utils
import { getMeasurementBySize } from '../../../utils/icon';

// Component
import Icon from '../Icon/Icon';

const IconContract = (props: IconType) => {
  const {
    size,
    inverse,
    onClick,
    width,
    height,
    fill,
    iconClassName,
  } = props;

  const defaultMeasurements: Measurements = {
    height: 16,
    width: 12,
  }

  const measurements = size ? getMeasurementBySize(size) : defaultMeasurements;

  return (
    <Icon inverse={inverse} onClick={onClick} className={iconClassName} classNameIconType="c-icon-contract">
      <svg className="c-icon-contract fill-current" width={width || measurements.width} height={height || measurements.height} viewBox="0 0 12 16" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M10.4676 0H1.53238C0.685961 0 0 0.674069 0 1.50493V14.4951C0 15.3259 0.685961 16 1.53238 16H10.4676C11.314 16 12 15.3259 12 14.4951V1.50493C12 1.10612 11.8388 0.723194 11.551 0.440711C11.264 0.15895 10.8739 0 10.4676 0ZM2.47599 2.39499H5.17265C5.49428 2.39932 5.75336 2.65725 5.75336 2.97297C5.75336 3.28941 5.49428 3.54663 5.17265 3.55096H2.47599C2.15435 3.54662 1.89601 3.28941 1.89601 2.97297C1.89601 2.65725 2.15435 2.39931 2.47599 2.39499ZM9.52401 13.6101H8.59222C8.20508 13.6087 7.83413 13.4577 7.56032 13.1904C7.51322 13.1347 7.44182 13.1044 7.36823 13.108C7.20851 13.142 7.06792 13.2344 6.97594 13.3674C6.87878 13.4873 6.73674 13.5646 6.58143 13.5812C6.42613 13.5985 6.27083 13.5545 6.14864 13.4591C5.42146 12.7923 6.68372 11.9549 7.28947 11.9542C7.69649 11.9332 8.09393 12.0821 8.38319 12.3638C8.43765 12.4202 8.51273 12.4527 8.59222 12.4541H9.52401H9.52328C9.84491 12.4592 10.1033 12.7164 10.1033 13.0321C10.1033 13.3478 9.84491 13.6051 9.52401 13.6101ZM9.52401 10.5996H2.47599C2.15435 10.5945 1.89601 10.3373 1.89601 10.0216C1.89601 9.70518 2.15435 9.44796 2.47599 9.44363H9.52401C9.84565 9.44797 10.104 9.70518 10.104 10.0216C10.104 10.3373 9.84565 10.5946 9.52401 10.5996ZM9.52401 8.25011L2.47599 8.24939C2.15435 8.24506 1.89601 7.98785 1.89601 7.67141C1.89601 7.35569 2.15435 7.09775 2.47599 7.09342H9.52401C9.84565 7.09776 10.104 7.35569 10.104 7.67141C10.104 7.98785 9.84565 8.24506 9.52401 8.24939V8.25011ZM9.52401 5.90063H2.47599C2.15435 5.89629 1.89601 5.63836 1.89601 5.32264C1.89601 5.0062 2.15435 4.74899 2.47599 4.74466H9.52401C9.84565 4.74899 10.104 5.0062 10.104 5.32264C10.104 5.63836 9.84565 5.8963 9.52401 5.90063Z" fill={fill || '#EF8541'} />
      </svg>
    </Icon>
  );
};

export default IconContract;
